export default __webpack_public_path__ + "static/media/nocasefile.a92ac641.svg";